import React from "react";

export type ViewKey = "blog" | "music" | "websites" | "contact";

type Props = {
  active: ViewKey;
  onSelect: (view: ViewKey) => void;
};

const LeftMenu: React.FC<Props> = ({ active, onSelect }) => {
  const Item: React.FC<{
    view: ViewKey;
    label: string;
    icon?: React.ReactNode;
  }> = ({ view, label, icon }) => (
    <button
      type="button"
      className="chunky-item"
      aria-current={active === view ? "page" : undefined}
      onClick={() => onSelect(view)}
      style={{ background: "#ffffff" }}
    >
      <span className="chunky-icon" aria-hidden>
        {icon}
      </span>
      <span className="chunky-label">{label}</span>
    </button>
  );

  return (
    <aside className="left-menu" aria-label="Site sections">
      <Item
        view="blog"
        label="Home"
        icon={
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 3l9 8h-3v9h-5v-6H11v6H6v-9H3z" fill="currentColor" />
          </svg>
        }
      />
      <Item
        view="music"
        label="Music"
        icon={
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M9 18a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm9-13.5V16a3 3 0 1 0 2 2V6.5l-9 2V18a3 3 0 1 0 2 2V6.5l7-2Z" fill="currentColor" />
          </svg>
        }
      />
      <Item
        view="websites"
        label="Websites"
        icon={
          <svg viewBox="0 0 24 24" width="20" height="20">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M3 12h18M12 3c3 4 3 14 0 18M12 3c-3 4-3 14 0 18" stroke="currentColor" strokeWidth="2" fill="none" />
          </svg>
        }
      />

      <style>
        {`
          .left-menu {
            position: sticky;
            position: -webkit-sticky;
            top: 96px; /* sit just below sticky header */
            display: grid;
            gap: 10px;
            margin-bottom: 16px;
            margin-left: 4px;
            z-index: 1; /* above boombox */
          }

          .chunky-item {
            display: grid;
            grid-template-columns: 28px 1fr;
            align-items: center;
            gap: 10px;
            text-align: left;
            padding: 12px 14px;
            border: 4px solid #000;
            box-shadow: 6px 6px 0 #000;
            font-weight: 900;
            text-transform: uppercase;
            cursor: pointer;
          }
          .chunky-item[aria-current="page"] {
            outline: 3px dashed #000;
            outline-offset: 2px;
          }
          .chunky-item:active { transform: translate(-2px, -2px); box-shadow: 8px 8px 0 #000; }

          .chunky-icon { display: inline-flex; align-items: center; justify-content: center; }
          .chunky-label { letter-spacing: 0.5px; }

          @media (max-width: 760px) {
            .left-menu { display: none; }
          }
        `}
      </style>
    </aside>
  );
};

export default LeftMenu;
